/* eslint-disable @typescript-eslint/no-explicit-any */
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import _ from 'lodash';

export function fetch(businessId: number, serviceDate: any): ApiAction {
  return {
    TockApi: {
      getListProto: `/internal/reportdata/events?businessId=${businessId}&serviceDate=${serviceDate}`,
      type: ClowncarAppConstants.FETCH_EVENTS,
    },
  };
}

export function fetchBaseState(businessId: number, serviceDate: any): ApiAction {
  return {
    TockApi: {
      getProto: `/internal/reportdata/basestate?businessId=${businessId}&serviceDate=${serviceDate}`,
      type: ClowncarAppConstants.FETCH_BASE_STATE,
      onError: {
        1001: _.noop, // NOT FOUND: will happen when choosing service topic without a base state
        defaultToOriginal: true,
      },
    },
  };
}
